/**
 * Combines an object of array of keys together into an array of objects
 * using the same keys
 * @param {{[key: string]: [any]}} object
 * @returns {[{[key: string]: any}]}
 *
 * Array values can be any length.
 * If left over value, an object will be instantiated with just that value.
 *
 * Example:
 * {
 *  brand: ["toyota", "lexus"],
 *  car: ["4 wheel drive", "motorcycle", "sedan"]
 * }
 *
 * Result:
 *  [
 *      {brand: "toyota", car: "4 wheel drive"}, {brand: "lexus", car:"sedan"},
 *      {brand: "", car: "sedan"}
 *  ]
 */
function mappedList(object) {
  // Length of Array to return
  let maxLength = 0;
  let combinedItemTemplate = {};
  let keys = [];
  Object.keys(object).forEach((key, i) => {
    maxLength = Math.max(object[key]?.length, maxLength);
    combinedItemTemplate = { ...combinedItemTemplate, [key]: '' };
    keys.push(key);
  });

  const array = [];

  const objectLength = Object.keys(combinedItemTemplate).length;
  for (let i = 0; i < maxLength; i++) {
    const combinedItem = {
      ...combinedItemTemplate,
    };
    for (let j = 0; j < objectLength; j++) {
      combinedItem[keys[j]] = object[keys[j]]?.[i];
    }
    array.push(combinedItem);
  }
  return array;
}

export default mappedList;
